import React from 'react';
import {connect} from 'react-redux';
import accountManagement from '../../../../../apis/accountManagement';
import KelasSearch from '../../../../../entity/KelasSearch';
import KelasParalelSearch from '../../../../../entity/KelasParalelSearch';
import SiswaKelasParalel from '../../../../../entity/SiswaKelasParalel';
import {cekCookies} from '../../../../../actions';
import Navbar from '../../../navbar/Navbar';
import Sidebar from '../../../sidebar/Sidebar';
import { CONFIG } from '../../../../../config';
import LoaderModal from '../../../../modal/LoaderModal';
import Loader from '../../../../Loader';
import __ from 'lodash';
import { Alert, Row } from 'react-bootstrap';


import DropdownKelas from '../../masterDropDown/DropdownKelas';
import DropdownKelasParalel from '../../masterDropDown/DropdownKelasParalel';
import DropdownTahunAjaran from '../../masterDropDown/DropdownTahunAjaran';
import { Switch, Checkbox, Button } from '@material-ui/core';


class UpdateJenjang extends React.Component{
    constructor(props){
        super(props);
        this.state = {   
            isFetching: false, 
            isLoading: false,        
            alertShow: false,
            alertMessage: '',
            warnaAlert : '',
            kodeTaLama: null,
            dataSiswa : [],
            sekolah:{},           
            ta:[],          
            kelas:[], 
            KelasParalelSearch :[],
            kelasBaru:[], 
            kpBaru :[],
            idKelasBaru : null,
            idKpBaru : null,
            idSiswaSelected : [],
            checkAll : false,
            tingkatanKelasLama : null,
            tingkatanKelasBaru : null

        }
    }

    async componentDidMount(){
        this.setState({isFetching: true});
        await this.props.cekCookies();
        this.setState({isFetching: false});
        if(!__.isEmpty(this.props.account)){
            this.fetchKelas();
            this.fetchTa();
        }  
        this.setState({
            isFetching: false
        });
    }



    fetchTa = async () =>{
        //fetch tahun ajaran dulu
        const resTa = await accountManagement.get(CONFIG.ACCOUNT_MANAGEMENT_LIST_TAHUN_AJARAN).catch(function(error){
        })
        if(resTa){
            if(resTa.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    ta: resTa.data.data
                })
            }
        }

        // resTa.data.data.map((val) =>{
        //     if(val.status == "1"){
                this.setState({kodeTaLama:''})
        //     }
        // })
        
    }

    fetchKelas = async () =>{
        this.setState({isFetching: true});

        //fetch sekolah dulu
        const resSekolah = await accountManagement.get(CONFIG.ACCOUNT_MANAGEMENT_GET_SEKOLAH + this.props.account.idSekolah).catch(function(error){
        })
        if(resSekolah){
            if(resSekolah.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    sekolah: resSekolah.data.data
                })
            }
        }

        //fetch kelas setelah dapat data sekolah
        const response = await accountManagement.post(CONFIG.ACCOUNT_MANAGEMENT_SEARCH_KELAS, {KelasSearch, ["kodeJenjangSekolah"]: this.state.sekolah.kodeJenjangSekolah}).catch(function(error){
        });

        // masukan data kelas ke dropdown
        if(response){
            if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    kelas: response.data.data,
                    kelasBaru: response.data.data
                })
            }
        }
        this.setState({isFetching: false});
    }


    /* HANDLE KELAS LAMA */
    hanldeOnChangeTa = async (idTa) => {
        this.setState({            
            kodeTaLama: idTa.target.value
        })
    }

    handleOnChangeKelas = async (idKelas) => {
        this.setState({            
            idKelas: idKelas.target.value
        })
        
        this.setState({isFetching: true});
        this.state.KelasParalelSearch=[];
        this.state.SiswaKelasParalel=[];
        this.setState({idKp : ''})
        //fetch kelas pararelnya dulu
        const resKelasParalel = await accountManagement.post(CONFIG.ACCOUNT_MANAGEMENT_SEARCH_KELAS_PARALEL, {KelasParalelSearch,['idKelas']: idKelas.target.value, ['idSekolah']: this.props.account.idSekolah}).catch (function(error){
        })  

        // masukan kelas paralel ke  dropdown
        if(resKelasParalel){
            if(resKelasParalel.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    KelasParalelSearch: resKelasParalel.data.data
                })
            }
        }
        // this.showSiswaSearch();

        this.setState({isFetching: false});
    }

    handleOnChangeKelasParalel = async (idKelasParalel) => {
        this.setState({isLoading : true});
        if(!__.isEmpty(idKelasParalel.target.value)){
            this.setState({            
                idKp: idKelasParalel.target.value,
                dataSiswa : []
            })   
        }  
        
        // cari siswa di kelas tersebut
        const resSiswaKelasParelel = await accountManagement.post(CONFIG.ACCOUNT_MANAGEMENT_SEARCH_SISWA_BY_KELAS_PARALEL,{...SiswaKelasParalel,
            ['idKelas']: this.state.selectedKelas,
            ['idKelasParalel']: idKelasParalel.target.value,
            ['idSekolah']: this.props.account.idSekolah,
            ['kodeTahunAjaran']: this.state.kodeTaLama
        }).catch (function(error){
        })

        // masukan siswa ke array
        if(resSiswaKelasParelel){
            if(resSiswaKelasParelel.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    dataSiswa: resSiswaKelasParelel.data.data
                })
            }
        }
        this.setState({isLoading : false});
    }

    /* HANDLE KELAS BARU */
    handleOnChangeKelasBaru = async (idKelas) => {
        this.setState({   
            alertShow : false,
            warnaAlert : 'warning',         
            idKelasBaru: idKelas.target.value
        })
        
        this.setState({isFetching: true});
        this.state.kpBaru=[];
        this.setState({idKpBaru : ''})
        //fetch kelas pararelnya dulu
        const resKelasParalel = await accountManagement.post(CONFIG.ACCOUNT_MANAGEMENT_SEARCH_KELAS_PARALEL, {KelasParalelSearch,['idKelas']: idKelas.target.value, ['idSekolah']: this.props.account.idSekolah}).catch (function(error){
        })  

        // masukan kelas paralel ke  dropdown
        if(resKelasParalel){
            if(resKelasParalel.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    kpBaru: resKelasParalel.data.data
                })
            }
        }
        // this.showSiswaSearch();

        this.setState({isFetching: false});
    }

    handleOnChangeKelasParalelBaru = async (idKelasParalel) => {
        if(!__.isEmpty(idKelasParalel.target.value)){
            this.setState({    
                alertShow : false,
                warnaAlert : 'warning',         
                idKpBaru: idKelasParalel.target.value
            })   
        }  
    }

    renderDataSiswa(){
        if(!__.isEmpty(this.state.dataSiswa)){            
            return this.state.dataSiswa.map((val,i) => {
                return (
                    <tr key={val.idSiswa+1}>
                        <td>{i+1}</td>
                        <td>{val.username}</td>
                        <td>{val.namaSiswa}</td>
                        <td>
                            {this.renderAllOrMany(val.idSiswa)}
                        </td>
                    </tr>
                )
            })           
        }else{
            return(
                <tr key={1}>
                    <td colSpan="4" style={{'alignContent' : 'center'}}></td>
                </tr>
            )
        }
    }

    renderAllOrMany(idSiswa){
        const {idSiswaSelected} = this.state; 
        if(this.state.checkAll){
            return(
                <Switch color="secondary" value={idSiswa} 
                onChange={e => this.handleChangeSwitch(e)}
                checked = {true} />
            )
        }
        else{
            return(
                <Switch color="secondary" value={idSiswa} 
                onChange={e => this.handleChangeSwitch(e)}
                defaultChecked={false}
                />
            )
        }
    }

    handleChangeSwitch(e){
        this.setState({
            alertShow : false,
            alertMessage : ''
        }); 
        let isChecked = e.target.checked;
        let idSiswa = e.target.value;
        const { dataSiswa, idSiswaSelected } = this.state;

        if(isChecked) {
            dataSiswa.map( val => {
                if (val.idSiswa == idSiswa) {                    
                    this.setState(prevState => ({
                        idSiswaSelected: [...prevState.idSiswaSelected, val.idSiswa]
                      }));
                } 
            })
            
        } else {
            this.setState({ 
                idSiswaSelected: idSiswaSelected.filter(v => v.idSiswa != idSiswa)
            });
        }    
        console.log(this.state.idSiswaSelected)
    
    }
    
    renderSwitchCheckAll(){
        if(!__.isEmpty(this.state.dataSiswa)){            
            return (
                <>
                    <div className="row pull-right fixed_button">
                        <div className="col-md-12">
                            {/* <b style={{'color': 'brown'}}>Tandai semua siswa   </b>
                            <Switch color="secondary" value='checkkAll'
                                onChange={e => this.doCheckAll(e)}
                            /> */}
                            <button className="btn btn-outline-primary btn133w pull-right" 
                            onClick={() => this.doUpdate()} autoFocus>Simpan</button>
                        </div>                        
                    </div>
                </>
            )
        }
    }

    doCheckAll(e){ 
        this.setState({checkAll : e.target.checked}); 
    }

    doUpdate= async () =>{
        this.setState({
            isFetching: true,
            alertShow : false,
        });

        if(this.state.idSiswaSelected.length>0){
            var tingkatanBaru, tingkatanLama;
            for (let i = 0; i < this.state.kelas.length; i++) {
                if(this.state.kelas[i].idKelas == this.state.idKelas)
                    tingkatanLama = this.state.kelas[i].tingkatanKelas;                    
            }
            for (let i = 0; i < this.state.kelas.length; i++) {
                if(this.state.kelas[i].idKelas == this.state.idKelasBaru)
                    tingkatanBaru = this.state.kelas[i].tingkatanKelas;                    
            }

            if(parseInt(tingkatanLama) >= parseInt(tingkatanBaru)){
                this.setState({
                    alertShow : true,
                    alertMessage : 'Kelas tujuan tidak diperbolehkan',
                    warnaAlert : 'warning',
                    isFetching: false,
                    idSiswaSelected : [],
                    dataSiswa : []
                }); 
                return;
            }


            const dataSend = {
                ['dataSiswa']: this.state.idSiswaSelected,
                ['idKelas']: this.state.idKelasBaru,
                ['idKelasParalel']: this.state.idKpBaru,
                ['isUpdateJenjang'] : true
            }
            console.info('dataSend', dataSend);

            const response = await accountManagement.post(CONFIG.ACCOUNT_MANAGEMENT_UPDATE_JENJANG, dataSend)
            .catch(function(error) {
                console.error(error);
            });

            if(response){
                if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                    this.setState({
                        alertShow : true,
                        alertMessage : 'Berhasil Update Kelas',
                        warnaAlert : 'info',
                        idSiswaSelected : [],
                        dataSiswa : [],
                        kelasBaru : [],
                        kpBaru : [],
                        idKelas : null,
                        idKelasParalel : null,
                        idKelasBaru : null,
                        isFetching: false
                    });
                    this.fetchKelas();
                    this.fetchTa();
                }
            }

        }else{
            this.setState({
                alertShow : true,
                alertMessage : 'Silahkan pilih siswa nya dulu',
                warnaAlert : 'warning',
                isFetching: false
            }); 
        }
    }

    render(){
        require ('./css.css');
        return(
            <div className="wrapper">
                <LoaderModal isFetching={this.state.isFetching} />
                <Sidebar account={this.props.account}/>
                <div id="content" style={{paddingBottom: '50px'}}>
                    <Navbar title={'Update Jenjang Siswa'}/>  
                    <div className="row">
                        {/* PANEL LAMA */}
                        <div className="col-md-6">
                            <div class="card">
                                <div class="card-header" style={{'background-color': 'rgba(104, 255, 248, 0.52)'}}>
                                    Pilih kelas lama
                                </div>
                                <div class="card-body">
                                    <div className="form-group">
                                        <label>Tahun ajaran</label>
                                        <select className="form-control" value={this.state.kodeTaLama} onChange={this.hanldeOnChangeTa} required>
                                            <option value="" selected disabled>~~ Pilih Tahun Ajaran ~~</option>
                                            <DropdownTahunAjaran tahunAjaran={this.state.ta} />
                                        </select>  
                                    </div>
                                    <div className="form-group">
                                        <label>Kelas</label>
                                        <select className="form-control" value={this.state.idKelas} onChange={this.handleOnChangeKelas} required>
                                            <option value="" selected disabled>~~ Pilih Kelas ~~</option>
                                            <DropdownKelas kelas={this.state.kelas} />
                                        </select>
                                    </div>
                                    <div className="form-group">
                                        <label>Kelas Paralel</label>
                                        <select className="form-control" value={this.state.idKp} onChange={this.handleOnChangeKelasParalel} required>
                                            <option value="" selected disabled>~~ Pilih Kelas Paralel ~~</option>
                                            <DropdownKelasParalel kelasParalel={this.state.KelasParalelSearch} />
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* PANEL BARU */}
                        <div className="col-md-6">
                            <div class="card">
                                <div class="card-header" style={{'background-color': 'rgba(255, 0, 0, 0.39)'}}>
                                    Pilih kelas baru
                                </div>
                                <div class="card-body">
                                    <div className="form-group">
                                        <label>Tahun ajaran</label>
                                        <select className="form-control" disabled>
                                            <option value="" selected disabled>~~ Pilih Tahun Ajaran ~~</option>
                                            <DropdownTahunAjaran tahunAjaran={this.state.ta} />
                                        </select>  
                                    </div>
                                    <div className="form-group">
                                        <label>Kelas</label>
                                        <select className="form-control" value={this.state.idKelasBaru} onChange={this.handleOnChangeKelasBaru} required>
                                            <option value="" selected disabled>~~ Pilih Kelas ~~</option>
                                            <DropdownKelas kelas={this.state.kelasBaru} />
                                        </select>
                                    </div>
                                    <div className="form-group">
                                        <label>Kelas Paralel</label>
                                        <select className="form-control" value={this.state.idKpBaru} onChange={this.handleOnChangeKelasParalelBaru} required>
                                            <option value="" selected disabled>~~ Pilih Kelas Paralel ~~</option>
                                            <DropdownKelasParalel kelasParalel={this.state.kpBaru} />
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
 
                    <br></br>
                    {this.loading()}
                    {this.loadAlert()} 
                    <table className="table table-sm table-striped table-hover">
                        <thead>
                            <tr>
                                <th width="10%">No</th>
                                <th width="25%">Username</th>
                                <th width="45%">Nama</th>
                                <th width="20%">Pilih Siswa</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.renderDataSiswa()}
                        </tbody>
                    </table>
                    {this.loading()}
                    {this.renderSwitchCheckAll()}
                </div>
            </div>
        )
    }

    loading = () =>{
        if(this.state.isLoading){
            return(
                <Loader />
            )
        }
    }

    loadAlert = () => {
        const {alertShow, alertMessage } = this.state;
      
        if (alertShow) {
          return (
            <Alert variant={this.state.warnaAlert} onClose={() => this.setState({ alertShow: false })} dismissible>   
                <strong>{alertMessage}</strong>
            </Alert>
          );
        } 
    }
}

const mapStateToProps = (state) => {
    return{
        account: state.account
    };
}

export default connect(mapStateToProps, {cekCookies})(UpdateJenjang);